<template>
  <div>
    <v-card>
      <v-card-title class="headline">Пропуск
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-row>
              <p class="subtitle-2 text-left ml-2">
                  <v-chip :color="status_descr(GETTERS_PASS_ALL.status, 'color')" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-calendar-month</v-icon>
                    </v-avatar>
                        <b style="color:white;">{{format_dateinterval(GETTERS_PASS_ALL)}}</b>
                  </v-chip>
              </p>
            </v-row>
            <v-row style="margin-top: -16px !important;" class="ml-2">
              <p v-if="GETTERS_PASS_ALL.type == 2" class="mb-0 ml-2">до 18:00 (без сопровождения)</p>
              <p v-if="GETTERS_PASS_ALL.type == 1" class="mb-0 ml-2">до 23:00 (с сопровождением)</p>
            </v-row>
          </v-col>
          <v-col v-if="GETTERS_PASS_ALL.need_applicant_equipment_pass">
            <p
              class="subtitle-2 text-left"
            >
                <v-chip color="#ff0000" text-color="white">
                      <b style="color:white;">требуется мат.пропуск</b>
                </v-chip>
            </p>
          </v-col>
          <v-col>
            <p
              class="subtitle-2 text-left"
            >
                <v-chip :color="status_descr(GETTERS_PASS_ALL.status, 'color')" text-color="white">
                      <b style="color:white;">{{status_descr(GETTERS_PASS_ALL.status, 'descr')}}</b>
                </v-chip>
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p class="subtitle-2 text-left">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-google-circles</v-icon>
                  </v-avatar>
                  <b
                    style="color:white;"
                  >{{GETTERS_PASS_ALL.proposal.station}} ({{ place_descr(GETTERS_PASS_ALL.place) }})</b>
                </v-chip>
            </p>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row>
          <v-col cols="3">
            <v-card-text>
              <p> Инициатор: </p>
            </v-card-text>
          </v-col>
          <v-col cols="9">
            <p class="subtitle-2 text-left">
              <v-badge color="red lighten-2" :content="GETTERS_PASS_ALL.creator.individual.phone_number" x-small overlap>
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-account</v-icon>
                  </v-avatar>
                  <b
                    style="color:white;"
                  >{{ GETTERS_PASS_ALL.creator.individual.last_name }} {{ GETTERS_PASS_ALL.creator.individual.first_name }} {{ GETTERS_PASS_ALL.creator.individual.middle_name }}</b>
                </v-chip>
              </v-badge>
            </p>

          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row style="padding-right: 80px;">
          <v-col cols="3">
            <v-card-text>
              <p> Гости: </p>
            </v-card-text>
          </v-col>
          <v-col cols="9">
            <v-card-text v-for="guest in GETTERS_PASS_ALL.guest" :key="guest.id" style="text-align: left; font-size: 14px; padding: 0px; padding-left: 15px;">
              <p><b> {{ guest.individual.last_name }} {{ guest.individual.first_name }} {{ guest.individual.middle_name }}</b> , {{ guest.individual.phone_number }}
                <br>   - {{ guest.individual.organization }}</p>
            </v-card-text>

          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row style="padding-right: 80px;">
          <v-col cols="3">
            <v-card-text>
              <p> Ответственный: </p>
            </v-card-text>
          </v-col>
          <v-col cols="9">
            <div v-for="resp in GETTERS_PASS_ALL.responsible" :key="resp.id" >
              <v-row>
                <p class="subtitle-2 text-left">
                  <v-badge color="red lighten-2" :content="resp.individual.phone_number" x-small overlap>
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-account</v-icon>
                      </v-avatar>
                      <b style="color:white;">
                        {{ resp.individual.last_name }} {{ resp.individual.first_name }} {{ resp.individual.middle_name }}
                      </b>
                    </v-chip>
                  </v-badge>
                </p>

              </v-row>

            </div>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row style="padding-right: 80px;">
          <v-col cols="3">
            <v-card-text>
              <p> Обоснование, доп.информация: </p>
            </v-card-text>
          </v-col>
          <v-col cols="9">
            <p v-if="GETTERS_PASS_ALL.reason"> {{ GETTERS_PASS_ALL.reason }}</p>
            <p v-else> - не указано</p>
          </v-col>
        </v-row>

      </v-card-text>

    </v-card>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'passModalCard',

  data: () => ({
  }),

  computed: {
    ...mapGetters([
      'GETTERS_PASS_ALL',
    ]),
  },

  methods: {
    place_descr(place){
      if(place == 1)
        return 'территория, 348'
      else if(place == 2)
        return 'территория, 21Б'
      else
        return 'территория'
    },

    status_descr(status, type){
      if(type == 'descr'){
        if (status == 4)
          return 'Черновик'
        else if (status == 0)
          return 'Новый запрос'
        else if (status == 1)
          return 'Оформляется'
        else if (status == 2)
          return 'Готов'
        else if (status == 3)
          return 'Отменен'
        else if (status == 5)
          return 'Удален'
        else
          return 'Не определен'
      }
      else{
        if (status == 0 || status == 4)
          return '#a9a9a9'
        else if (status == 1)
          return '#ada509'
        else if (status == 2)
          return '#1b8e30'
        else if (status == 3)
          return 'red lighten-2'
        else if (status == 5)
          return '#794606'
        else
          return 'red lighten-2'
      }
    },

    format_dateinterval(item){
      var date_obj_1 = new Date(item.start_date)
      var date_obj_2 = new Date(item.finish_date)

      return this.formate_date(date_obj_1) + ' : ' + this.formate_date(date_obj_2)
    },
    formate_date(date_obj){
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate()
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date + '.' + month + '.' + date_obj.getFullYear()
    },
  }

};
</script>
